import { NewLeaderboard } from ".";
export default {
  path: "leaderboard",

  childRoutes: [{ path: "/", component: NewLeaderboard, isIndex: true }],
};
